import type { TUseAppReturn } from './app.types';

const useApp = (): TUseAppReturn => {
	return {
		isReady: true
	};
};

export { useApp };
